import { render, staticRenderFns } from "./wallet-modal.vue?vue&type=template&id=795692fc&scoped=true&"
import script from "./wallet-modal.vue?vue&type=script&lang=js&"
export * from "./wallet-modal.vue?vue&type=script&lang=js&"
import style0 from "./wallet-modal.vue?vue&type=style&index=0&id=795692fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795692fc",
  null
  
)

export default component.exports